module.exports = __webpack_public_path__ + "static/media/pokeball.dfadb7aa.png";